
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import CollapseItem from '@/components/collapse.vue';
import shoplist from '@/components/shoplist.vue';
import Switch from '@/components/switch.vue';
import {
	activityMarkdowndetail,
	activityMarkdownsave,
} from "@/api/material"
import { number } from 'echarts';
@Component({
	name: '',
	components: {
		PageFooter,
		CollapseItem,
		shoplist,
		'slz-switch': Switch,
	}
})

export default class ProductIds extends Vue {
	private loading = false
	private form: any = {
		Id: this.$route.query.Id || 0,
		ActivityName: '',
		StartTime: '',
		EndTime: '',
		Type: 0,
		Condition: '',
		MarkdownMoney: '',
		Label: '',
		IsExcept: 0,
		ProductIds: [],
		ProductList: [],
		ActivityState: 0,
		IsProductControlPrice: false,
		JoinObject: [0, 1],
		LadderList: [
			{
				Id: 0,
				Condition: '',
				MarkdownMoney: '',
				Level: 0
			}
		]
	}
	private tablelist = []
	private pageSize = 10
	private pageNo = 1
	private total = 0
	private defaultThumb = 'https://cdn2024.shiwuzone.com/routuanapp/default-thumb.png';
	private shopShow = false
	private caps = ['一', '二', '三', '四', '五'];


	private mounted() {
		if (Number(this.$route.query.Id)) {
			this.getinfo()
		}
	}
	private switchChange(){
		let bol = this.form.IsProductControlPrice;
		console.log(bol, this.form.JoinObject[0])
		if (bol && this.form.JoinObject[0] !== 0){
			this.form.JoinObject.unshift(0)
		}
	}
	private handleAddLadder(){
		this.form.LadderList.push({
			Id: 0,
			Condition: '',
			MarkdownMoney: '',
			Level: this.form.LadderList.length
		})
	}
	private handleDeleteLadder(index){
		this.form.LadderList.splice(index, 1);
		this.form.LadderList.map((item, index)=>{
			item.Level = index;
			return item;
		})
		this.getlabel();
	}
	private check() {
		if (!this.form.ActivityName) {
			this.$message.error('请输入活动名称')
			return false
		} else if (!this.form.StartTime || !this.form.EndTime) {
			this.$message.error('请完善活动时间')
			return false
		} else if (new Date(this.form.StartTime).getTime() > new Date(this.form.EndTime).getTime()) {
			this.$message.error('结束时间不能早于开始时间')
			return false
		} else if (this.form.Type === 1 || this.form.Type === 3){
			if (!this.form.Condition) {
				this.$message.error('请填写消费金额')
				return false
			} else if (!this.form.MarkdownMoney) {
				this.$message.error('请填写优惠金额')
				return false
			} else if (this.form.Condition < 0.01 || this.form.Condition > 1000000 || this.form.MarkdownMoney < 0.01 || this.form.MarkdownMoney > 1000000) {
				this.$message.error('金额请填写0.01~1000000之内的数字，最多2位小数')
				return false
			}
		}else if (this.form.Type === 0 || this.form.Type === 2) {
			let str = '';
			this.form.LadderList.map(item=>{
				if (!str){
					if (!item.Condition) {
						str = '请填写消费金额';
					} else if (!item.MarkdownMoney) {
						str = '请填写优惠金额';
					} else if (item.Condition < 0.01 || item.Condition > 1000000 || item.MarkdownMoney < 0.01 || item.MarkdownMoney > 1000000) {
						str = '金额请填写0.01~1000000之内的数字，最多2位小数';
					}
				}
			})
			if (str){
				this.$message.error(str)
				return false
			}
		} else if (!this.form.ProductList || !this.form.ProductList.length) {
			this.$message.error('请选择活动商品')
			return false
		}
		return true
	}
	private async save() {
		if (!this.check()) return
		try {
			this.loading = true
			let res = await activityMarkdownsave({
				...this.form,
				ProductIds: this.form.ProductList.map(v => v.Id)
			})
			if (res.IsSuccess) {
				this.$message.success('保存成功')
				this.$router.go(-1)
			}
		} finally {
			this.loading = false
		}
	}
	private async getinfo() {
		try {
			this.loading = true
			let res = await activityMarkdowndetail({
				Id: this.$route.query.Id
			})
			if (res.IsSuccess) {
				if (!res.Result.LadderList.length){
					res.Result.LadderList = [
						{
							Id: 0,
							Condition: '',
							MarkdownMoney: '',
							Level: 0
						}
					]
				}
				this.form = {
					...res.Result,
					IsExcept: res.Result.IsExcept ? 1 : 0,
					Id: this.$route.query.Id || 0,
				}
				console.log(this.form)
				this.gettablelist()
			}
		} finally {
			this.loading = false
		}
	}

	private getlabel() {
		if(this.form.Type === 1 || this.form.Type === 3){
			if (this.form.Condition && this.form.MarkdownMoney) {
				this.form.Label = '满' + this.form.Condition + '元减' + this.form.MarkdownMoney + '元'
			}
		}else{
			let list = [];
			this.form.LadderList.map(item=>{
				if (item.Condition && item.MarkdownMoney) {
					list.push('满' + item.Condition + '元减' + item.MarkdownMoney + '元');
				}
			})
			this.form.Label = list.join(',');
		}
		
	}
	private delrow(row) {
		this.form.ProductList = this.form.ProductList.filter(v => {
			return v.Id != row.Id
		})
		this.gettablelist()
	}
	private getshop(list) {
		if (!list || !list.length) {
			this.$message.error('请选择商品')
			return
		}
		this.form.ProductList = list
		this.shopShow = false
		this.gettablelist()
	}
	private changePage(e) {
		this.pageNo = e
		this.gettablelist()
	}
	private gettablelist() {
		this.total = this.form.ProductList.length
		this.tablelist = this.form.ProductList.filter((v, i) => {
			return i >= (this.pageNo - 1) * this.pageSize && i < this.pageNo * this.pageSize
		})
		if (this.pageNo > 1 && (!this.tablelist || !this.tablelist.length)) {
			this.pageNo--
			this.gettablelist()
		}
	}
}
